export default __webpack_public_path__ + "static/media/sharyat_logo_orange.cd237a36.svg";